<template>
  <div class="template">
    <DefenseDesktop class="template__Desktop" />
    <DefenseMobile class="template__Mobile" />
  </div>
</template>

<script>
import DefenseMobile from '@/components/services/Defense/DefenseMobile.vue'
import DefenseDesktop from '@/components/services/Defense/DefenseDesktop.vue'
export default {
  name: 'ServicesView',
  components: {
    DefenseDesktop,
    DefenseMobile
  }
}
</script>


<style lang="scss">


.template__Desktop {
  display: none;
}

.template__Mobile {
  display: block;
}

@media screen and (min-width: 1024px) {
  .template__Desktop {
    display: block;
  }

  .template__Mobile {
    display: none;
  }
}
</style>